<template>
  <div class="home">
    <h1>欢迎您进入洗衣管理系统</h1>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created () { },
  methods: {}
}
</script>
<style lang="less" scoped>
.home {
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 111px);
}
</style>